"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
function setAttendeeReadinessCheck(payload) {
  return function (dispatch) {
    var action = {
      type: _types.SET_ATTENDEE_READINESS_CHECK,
      payload: payload
    };
    dispatch(action);
  };
}
var _default = exports["default"] = setAttendeeReadinessCheck;